import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

const DRY_SPELL_BASE_URL = 'https://metWISE.vassarlabs.com/wrimsApi/api/rf/';

@Injectable({
  providedIn: 'root'
})
export class DrySpellDataService {

  constructor(private http: HttpClient) {}

  getDrySpellHeatmap(year: number, monsoonBlock: string, source: string = 'IMD_GRID') {
    const url = `${DRY_SPELL_BASE_URL}drySpellHeatmap?year=${year}&monsoonBlock=${monsoonBlock}&source=${source}`;
    return this.http.get<{ base64Image: string; bbox: number[][] }>(url);
  }

  getDrySpellLocationData(body: {
    pUuid: string;
    pType: string;
    cType: string;
    source: string;
    startYear: string;
    endYear: string;
  }) {
    const url = `${DRY_SPELL_BASE_URL}drySpellLocationData`;
    return this.http.post<any>(url, body);
  }

  getAgriExposureLocationData(body: {
    pUuid: string;
    pType: string;
    cType: string;
    source: string;
    startYear: string;
    endYear: string;
  }) {
    const url = `${DRY_SPELL_BASE_URL}agriExposureLocationData`;
    return this.http.post<any>(url, body);
  }
}
